import { render } from "./AdminNewPage.vue?vue&type=template&id=33e3c8a2"
import script from "./AdminNewPage.vue?vue&type=script&lang=js"
export * from "./AdminNewPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__